module.exports = __webpack_public_path__ + "img/home_img_05.5c5b9374.png";